import { z } from 'zod';

export const leadPassengerCountryOptions = ['UK', 'Continental Europe', 'USA', 'Other'] as const;

const contactFormBase = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  message: z.string().min(1),
  countryOfResidence: z.string().min(1),
  email: z.string().email(),

  phone: z.string().optional(),
  whereDidYouHearAboutUs: z.string().optional(),
  newsletterSignup: z.boolean().optional(),
  marketingOptOut: z.boolean().optional(),

  medium: z.string().optional(),
  source: z.string().optional(),
  campaign: z.string().optional(),
  campaignid: z.string().optional(),
  gclid: z.string().optional(),
  tripType: z.string().optional(),
  utm_campaign: z.string().optional(),
  utm_source: z.string().optional(),
  locale: z.string().optional(), // Hidden, auto-populated metadata (not customer-facing)
  currency: z.string().optional(), // Hidden, auto-populated metadata (not customer-facing)

  middleName: z.string().optional(), // Honeypot field (should be empty)
  captcha: z.string()
});

export const contactFormSchema = contactFormBase;

export type ContactFormSchema = z.infer<typeof contactFormSchema>;
export const submitSchema = contactFormBase.omit({ captcha: true, middleName: true });
export type SubmitPayload = z.infer<typeof submitSchema>;
